export default __webpack_public_path__ + "static/media/Daily.a6a2fd73.svg";